import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/uz.ts
var add = "Qo'shish";
var remove = "O'chirish";
var removeAll = "Hammasini o'chirish";
var incomplete = "Kechirasiz, barcha maydonlar to'g'ri to'ldirilmagan.";
var submit = "Yuborish";
var noFiles = "Hech qanday fayl tanlanmagan";
var moveUp = "Yuqoriga ko’taring";
var moveDown = "Pastga siljish";
var isLoading = "Yuklanmoqda...";
var loadMore = "Ko’proq yuklang";
var next = "Keyingi";
var prev = "Oldingi";
var addAllValues = `Barcha qiymatlarni qo'shish`;
var addSelectedValues = `Tanlangan qiymatlarni qoʻshish`;
var removeAllValues = "Barcha qiymatlarni olib tashlang";
var removeSelectedValues = "Tanlangan qiymatlarni olib tashlash";
var chooseDate = "Sanani tanlang";
var changeDate = `O'zgartirish sanasi`;
var close = "Yopish";
var open = "Ochiq";
var accepted = function({
  name
}) {
  return `${name} ni qabul qiling.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ${date(args[0])} dan keyin bo'lishi kerak.`;
  }
  return `${sentence(name)} kelajakda bo'lishi kerak.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} faqat alifbo tartibidagi belgilardan iborat bo'lishi mumkin.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} faqat harflar va raqamlardan iborat bo'lishi mumkin.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} faqat harf va bo'shliqlardan iborat bo'lishi mumkin.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} alfavit belgilarini o'z ichiga olishi kerak.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} harflar yoki raqamlarni o'z ichiga olishi kerak.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} harflar yoki bo'shliqlar bo'lishi kerak.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} belgisi bo'lishi kerak.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} katta harfni o'z ichiga olishi kerak.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} kichik harflarni o'z ichiga olishi kerak.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} raqamlarini o'z ichiga olishi kerak.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} belgisi bo'lishi kerak.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} faqat katta harflarni o'z ichiga olishi mumkin.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} faqat kichik harflarni o'z ichiga olishi mumkin.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ${date(args[0])} dan oldin bo'lishi kerak`;
  }
  return `${sentence(name)} o'tmishda bo'lishi kerak.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Bu maydon noto'g'ri sozlangan va uni yuborib bo'lmaydi.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} ${a} va ${b} orasida bo'lishi kerak.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} mos emas.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} haqiqiy sana emas, iltimos ${args[0]} formatidan foydalaning`;
  }
  return "Bu maydon noto'g'ri sozlangan va uni yuborib bo'lmaydi";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} ${date(args[0])} va ${date(args[1])} oralig'ida bo'lishi kerak`;
};
var email = "Iltimos amaldagi e-mail manzilingizni kiriting.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} ${list(args)} bilan tugamaydi.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} ruxsat etilgan qiymat emas.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} kamida bitta belgidan iborat bo'lishi kerak.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} ${max2} ta belgidan kam yoki teng bo'lishi kerak.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} bo'lishi kerak ${max2} belgilar uzun.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} ${min2} ta belgidan ko'p yoki teng bo'lishi kerak.`;
  }
  return `${sentence(name)} ${min2} va ${max2} gacha belgilardan iborat bo'lishi kerak.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} ruxsat etilgan qiymat emas.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${args[0]} ${name} dan ortiq bo'lishi mumkin emas.`;
  }
  return `${sentence(name)} ${args[0]} dan kichik yoki teng bo'lishi kerak.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Fayl formatlariga ruxsat berilmagan.";
  }
  return `${sentence(name)} quyidagi turdagi bo'lishi kerak: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${args[0]} ${name} dan kam bo'lmasligi kerak.`;
  }
  return `${sentence(name)} kamida ${args[0]} bo'lishi kerak.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}" ruxsat berilmagan ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} raqam bo'lishi kerak.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" yoki ")} kerak.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} talab qilinadi.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} ${list(args)} bilan boshlanmaydi.`;
};
var url = function() {
  return `Iltimos, tegishli URL manzilini kiriting.`;
};
var invalidDate = "Tanlangan sana yaroqsiz.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var uz_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, uz_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=uz.mjs.map